import { useEffect } from "react";

/**
 * Lightweight head manager — updates document.title, meta description and
 * injects a JSON-LD <script> tag (removed on unmount).
 */
export default function SeoHead({ title, description, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);

  useEffect(() => {
    if (!description) return;
    let tag = document.querySelector('meta[name="description"]');
    const previous = tag ? tag.getAttribute("content") : null;
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", description);
    return () => {
      if (previous != null && tag) tag.setAttribute("content", previous);
    };
  }, [description]);

  useEffect(() => {
    if (!jsonLd) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(jsonLd);
    script.dataset.seo = "page-jsonld";
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [jsonLd]);

  return null;
}
